import { useCallback } from 'react'

import { useI18n } from '@/lib/i18n'

export function useSocialText() {
  const { t } = useI18n()
  return useCallback(
    (
      key: string,
      fallback: string,
      params?: Record<string, string | number>,
    ) => {
      const translated = t(key, params)
      return translated === key ? fallback : translated
    },
    [t],
  )
}
